import { TABBY_TEXT_FONT_FAMILY } from '../text/typography-constants';
import { SHADOW_VIEW_INITIAL_PROPERTIES } from './constants';

export const TABBY_BASE_FONT_DECLARATION = `font: normal 400 16px/normal "${TABBY_TEXT_FONT_FAMILY}", sans-serif !important;`;

const getActualInitialProperties = (inheritedProps: Record<string, boolean>) =>
  SHADOW_VIEW_INITIAL_PROPERTIES.filter((prop) => !inheritedProps[prop]);

const getTabbyStyles = () =>
  Array.from(document.querySelectorAll('style[data-app="tabby"]'));

const cloneStylesToShadowDom =
  (shadowRoot: ShadowRoot | null) => (node: Element) => {
    const nodeClone = node.cloneNode(true);
    shadowRoot?.appendChild(nodeClone);
  };

export const isShadowDomAvailable = Boolean(
  document.head.attachShadow || (document.head as any).createShadowRoot
);

const resetProperty = (property: string) => `${property}: initial !important;`;

export const attachStyles = (
  element: ShadowRoot,
  recordOfInheritedProperties: Record<string, boolean>
) => {
  element.innerHTML += `
    <style>
      :host {
        ${getActualInitialProperties(recordOfInheritedProperties)
          .map(resetProperty)
          .join('')}
        ${TABBY_BASE_FONT_DECLARATION}
      }
    </style>`;

  const tabbyStyles = getTabbyStyles();
  tabbyStyles.forEach(cloneStylesToShadowDom(element));
};
